import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';

// SERVICES

const styles = theme => ({
  tabBar: {
    // flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  tabsContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    paddingTop: 5,
    paddingBottom: 5,
  },
  tab: {
    padding: '10px 30px',
    borderRight: '1px solid #ccc',
    color: 'var(--jmi-blue)',
    cursor: 'pointer',
    fontSize: 15,
  },
  tabActive: {
    fontWeight: 'bold',
  },
});

export const TabBar = withStyles(styles)(props => {
  const { classes, tabs, changeTab, activeTab, extraContent, name} = props;

  return (
    <div className={classnames('align-stretch', 'border-left-green', 'mb-10', classes.tabBar)}>
      <div className={classnames('card', classes.tabsContainer)}>
        {tabs.map((tab, tabIdx) => (
          <div
            key={`tab-${tabIdx}-${tab.label}`}
            className={classnames(classes.tab, activeTab === tabIdx && classes.tabActive)}
            onClick={() => changeTab(tab.key)}
          >
            {tab.label}
          </div>
        ))}
        
      </div>
      {!!extraContent && <div className={classes.extraContent}>{extraContent}</div>}
    </div>
  );
});

TabBar.propTypes = {
  changeTab: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.object),
  activeTab: PropTypes.number.isRequired,
  extraContent: PropTypes.any,
};

TabBar.defaultProps = {};
